import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import './index.scss'

interface Props {
  images: Array<{ original: string }>
  autoPlay?: Boolean
}

const Gallery = ({ images, autoPlay }: Props) => {
  return (
    <ImageGallery
      showNav={false}
      items={images}
      showThumbnails={false}
      showBullets={true}
      showPlayButton={false}
      autoPlay={!!autoPlay}
      showFullscreenButton={false}
    />
  )
}

export default Gallery
